import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
  HomeIcon,
  UsersIcon,
  DocumentTextIcon,
  CreditCardIcon,
  ChartBarIcon,
  CogIcon,
  UserGroupIcon,

} from '@heroicons/react/24/outline';
import { GiGoldBar } from "react-icons/gi";

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'Customers', href: '/customers', icon: UsersIcon },
  { name: 'Loans', href: '/loans', icon: DocumentTextIcon },
  { name: 'Payments', href: '/payments', icon: CreditCardIcon },
  { name: 'Reports', href: '/reports', icon: ChartBarIcon },
  { name: 'Settings', href: '/settings', icon: CogIcon },
];

const adminNavigation = [
  { name: 'Users', href: '/users', icon: UserGroupIcon },
];

const MobileSidebar = ({ isOpen, onClose }) => {
  const { user } = useAuth();

  const isActive = (href) => {
    return window.location.pathname === href || window.location.pathname.startsWith(href + '/');
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50 lg:hidden" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/80" />
        </Transition.Child>

        <div className="fixed inset-0 flex">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button type="button" className="-m-2.5 p-2.5" onClick={onClose}>
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon className="h-6 w-6 text-primary-600" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              
              <div className="flex grow flex-col gap-y-5 overflow-y-auto  px-6 pb-2"  style={{
            borderColor: 'rgba(217, 119, 6, 0.35)',
            backgroundImage: 'linear-gradient(180deg, rgba(252,211,77,0.95) 0%, rgba(245,158,11,0.95) 45%, rgba(217,119,6,0.95) 100%)'
          }}>
                <div className="flex h-16 shrink-0 items-center">
                  <GiGoldBar  className="h-8 w-8 text-primary-600" />
                  <div className="ml-3">
                    <h1 className="text-xl font-bold text-primary-900">Gold Loan</h1>
                    <p className="text-xs text-primary-500">Management System</p>
                  </div>
                </div>
                
                <nav className="flex flex-1 flex-col">
                  <ul role="list" className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul role="list" className="-mx-2 space-y-1">
                        {navigation.map((item) => {
                          const Icon = item.icon;
                          return (
                            <li key={item.name}>
                              <NavLink
                                to={item.href}
                                onClick={onClose}
                                className={`group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold ${
                                  isActive(item.href)
                                    ? 'bg-gray-50 text-primary-600'
                                    : 'text-primary-700 hover:text-primary-600 hover:bg-gray-50'
                                }`}
                              >
                                <Icon
                                  className={`h-6 w-6 shrink-0 ${
                                    isActive(item.href)
                                      ? 'text-primary-600'
                                      : 'text-primary-400 group-hover:text-primary-600'
                                  }`}
                                  aria-hidden="true"
                                />
                                {item.name}
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                    
                    {/* Admin navigation */}
                    {user?.role === 'admin' && (
                      <li>
                        <div className="text-xs font-semibold leading-6 text-primary-400">
                          Administration
                        </div>
                        <ul role="list" className="-mx-2 mt-2 space-y-1">
                          {adminNavigation.map((item) => {
                            const Icon = item.icon;
                            return (
                              <li key={item.name}>
                                <NavLink
                                  to={item.href}
                                  onClick={onClose}
                                  className={`group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold ${
                                    isActive(item.href)
                                      ? 'bg-gray-50 text-primary-600'
                                      : 'text-primary-700 hover:text-primary-600 hover:bg-gray-50'
                                  }`}
                                >
                                  <Icon
                                    className={`h-6 w-6 shrink-0 ${
                                      isActive(item.href)
                                        ? 'text-primary-600'
                                        : 'text-primary-400 group-hover:text-primary-600'
                                    }`}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default MobileSidebar;
